<template>
  <div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <template v-if="emergencyStateLog !== null && emergencyStateLog.length > 0">
      <b-card
        v-for="item in emergencyStateLog"
        :key="item.Id"
        class="log-item"
      >
        <table>
          <tr>
            <th>Id</th>
            <td>
              {{item.Id}}
            </td>
          </tr>
          <tr>
            <th>Time</th>
            <td>
              {{item.Ctime | getMomentStr}}
            </td>
          </tr>
          <tr>
            <th>Player</th>
            <td>
              <player-link :playerId="item.PlayerId"/>
              &gt;
              <router-link
                :to="{name: 'player_emergency_state_log', params: {playerId: item.PlayerId}}"
              >emergency state log</router-link>
            </td>
          </tr>
          <tr>
            <th>Ext id</th>
            <td>
              {{item.ExtId}}
            </td>
          </tr>
          <tr>
            <th>Device id</th>
            <td>
              {{item.DeviceId}}
            </td>
          </tr>
        </table>
      </b-card>
    </template>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import PlayerLink from './PlayerLink.vue';

export default {
  name: 'EmergencyStateLog',

  components: {
    LoadingIndicator,
    PlayerLink,
  },

  data() {
    return {
      isLoading: false,
      emergencyStateLog: null,
    };
  },

  computed: {
    message() {
      if(this.emergencyStateLog !== null && this.emergencyStateLog.length === 0) {
        return 'Emergency state log is empty.';
      }
      return null;
    },
  },

  created() {
    this.isLoading = true;

    const url = '/emergency_state_log';
    HTTP.get(url)
    .then(response => {
      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }
      this.emergencyStateLog = data;
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style scoped>
.log-item {
  margin-bottom: 1em;
}

.log-item .card-body {
    padding: 8px;
}

.log-item th {
  padding-right: 0.5em;
}
</style>